import { useQuery } from '@tanstack/react-query';

import { managerTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';
import { Departments } from '@/types';

export const getManagers: managerTypes.GetManagers = (params) => {
  return axios.get(`/managers`, { params });
};

type QueryFnType = typeof getManagers;

type UseGetManagers = {
  department?: Departments;
  config?: QueryConfig<QueryFnType>;
};

export const useGetManagers = ({ config = {}, department }: UseGetManagers = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['managers', department],
    queryFn: () => getManagers({ department }),
  });
};
